import { normaliseQrCode } from "@/lib/qr/registry";

const KEY = "vitolier:fast_track_destination";
const TTL = 30 * 24 * 60 * 60 * 1000;
const HOME = "/app/home";

/** Only known, same-origin content destinations; never auth, admin or setup loops. */
export function safeFastTrackDestination(value: unknown): string | null {
  if (typeof value !== "string" || value.length > 500 || /[%\\?#\s]/.test(value)) return null;
  const path = value.replace(/^\/(en|es|fr|nl)(?=\/)/, "");
  if (path === HOME || path === "/app/journal") return path;
  if (/^\/patron\/invite\//.test(path)) {
    const code = normaliseQrCode(path.slice("/patron/invite/".length));
    return code ? `/patron/invite/${code}` : null;
  }
  if (/^\/(businesses|brands|cigars|lines|events|news|cigar-atlas)(\/[a-zA-Z0-9-]+){0,4}$/.test(path)) return path;
  return null;
}

export function saveFastTrackDestination(value: unknown): void {
  const destination = safeFastTrackDestination(value);
  if (!destination) return;
  try { localStorage.setItem(KEY, JSON.stringify({ destination, at: Date.now() })); } catch { /* optional storage */ }
}

export function readFastTrackDestination(): string | null {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? "null");
    if (!saved || typeof saved.at !== "number" || Date.now() - saved.at > TTL) return null;
    return safeFastTrackDestination(saved.destination);
  } catch { return null; }
}

export function clearFastTrackDestination(): void {
  try { localStorage.removeItem(KEY); } catch { /* optional storage */ }
}

export function resolveFastTrackDestination(params: URLSearchParams, metadata?: Record<string, unknown>): string {
  return safeFastTrackDestination(params.get("next"))
    ?? safeFastTrackDestination(metadata?.fast_track_destination)
    ?? readFastTrackDestination()
    ?? HOME;
}